<template>
  <div v-if="!loading">
    <Singular
      v-if="mostrarSingular"
      :podeEnviarArquivo="podeEnviarArquivo"
      :listaArquivos="listaArquivos"
      @upload-arquivo="uploadArquivo"
      @baixar-arquivo="baixarArquivo"
    />
    <Analista
      v-else
      :podeAprovarReprovar="podeAprovarReprovar"
      :listaArquivos="listaArquivos"
      :codigoUnimed="codigoUnimed"
      @aprovar-arquivo="aprovarArquivo"
      @reprovar-arquivo="reprovarArquivo"
      @baixar-arquivo="baixarArquivo"
    />
  </div>
  <unicom-spinner
    v-else
    style="min-height: 350px; display: flex; align-items: center"
    v-show="loading"
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
  />
</template>

<script>
import Singular from "./componentes/Singular/Singular";
import Analista from "./componentes/Analista/Analista";
import { EnumPerfis } from "../../../../../shared/helpers/Enum";
import TabAlteracoesMixin from "./TabAlteracoesMixin";

export default {
  mixins: [TabAlteracoesMixin],
  components: {
    Singular,
    Analista
  },
  props: {
    podeAprovarReprovar: {
      type: Boolean
    },
    podeEnviarArquivo: {
      type: Boolean
    },
    codigoUnimed: {
      type: [String, Number]
    }
  },
  computed: {
    mostrarSingular() {
      return this.papelUsuarioMixin.chave === EnumPerfis.SINGULAR;
    }
  }
};
</script>
